module.exports = __webpack_public_path__ + "static/img/img_iot_al_sjcj.3d7e50c2.png";